import { useEffect } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./index";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  getUiLanguage,
  normalizeUiLanguage,
  saveUiLanguage,
} from "./languages";

function LanguagePreferenceSync() {
  const { i18n: currentI18n } = useTranslation("common");
  const language = getUiLanguage(
    currentI18n.resolvedLanguage || currentI18n.language
  );

  useEffect(() => {
    document.documentElement.lang = language.code;
    document.documentElement.dir = language.direction;
    saveUiLanguage(language.code);
  }, [language.code, language.direction]);

  useEffect(() => {
    // Sama kieli päivittyy myös toiseen jo avoinna olevaan välilehteen.
    function handleStorageChange(event) {
      if (event.key !== LANGUAGE_STORAGE_KEY && event.key !== null) {
        return;
      }

      const nextLanguage =
        event.newValue === null
          ? DEFAULT_LANGUAGE
          : normalizeUiLanguage(event.newValue);

      if (nextLanguage && nextLanguage !== currentI18n.language) {
        currentI18n.changeLanguage(nextLanguage);
      }
    }

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [currentI18n]);

  return null;
}

export default function LanguageProvider({ children }) {
  return (
    <I18nextProvider i18n={i18n}>
      <LanguagePreferenceSync />
      {children}
    </I18nextProvider>
  );
}
